import { useMemo } from 'react';
import { fmtCurrency } from '../../../utils/formatNumber';
import { formatDate } from '../../../utils/dateUtils';
import styles from '../MemberReports.module.css';

const AnonymousDonationsReport = ({ receipts, filterYear }) => {
  const filtered = useMemo(() => {
    return receipts
      .filter(r => !filterYear || String(r.financialYearId) === filterYear)
      .sort((a, b) => new Date(b.receiptDate) - new Date(a.receiptDate));
  }, [receipts, filterYear]);

  const totalAmount = useMemo(() => {
    return filtered.reduce((s, r) => s + parseFloat(r.amountInr || 0), 0);
  }, [filtered]);

  return (
    <div className="card">
      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th style={{ width: 40 }}>#</th>
              <th>Date</th>
              <th>Receipt No</th>
              <th>Donor Name</th>
              <th>Category</th>
              <th>Mode</th>
              <th className={styles.amtRight}>Amount (₹)</th>
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 && (
              <tr>
                <td colSpan={7} className="empty-state">
                  No Shah A/C donations found for the selected criteria.
                </td>
              </tr>
            )}
            {filtered.map((r, i) => (
              <tr key={r.id}>
                <td>{i + 1}</td>
                <td>{formatDate(r.receiptDate)}</td>
                <td><code>{r.receiptNo}</code></td>
                <td>{r.donorName || 'Shah A/C'}</td>
                <td>
                  {r.donationCategory?.name ? (
                    <span className="badge badge-info" style={{ background: 'var(--color-bg-alt)', color: 'var(--color-text-primary)', border: '1px solid var(--color-border)' }}>
                      {r.donationCategory.name}
                    </span>
                  ) : '—'}
                </td>
                <td style={{ textTransform: 'capitalize' }}>{r.paymentMode?.replace('_', ' ')}</td>
                <td className={styles.amtRight}>
                  <strong>{fmtCurrency(r.amountInr)}</strong>
                </td>
              </tr>
            ))}
          </tbody>
          {filtered.length > 0 && (
            <tfoot>
              <tr>
                <td colSpan={6}>
                  <strong>Total ({filtered.length} entries)</strong>
                </td>
                <td className={styles.amtRight}>
                  <strong>{fmtCurrency(totalAmount)}</strong>
                </td>
              </tr>
            </tfoot>
          )}
        </table>
      </div>
    </div>
  );
};

export default AnonymousDonationsReport;
